import {
  DataGrid,
  GridActionsCellItem,
  GridColDef,
  GridEventListener,
  GridRowEditStopReasons,
  GridRowId,
  GridRowModel,
  GridRowModes,
  GridRowModesModel,
  GridRowsProp
} from '@mui/x-data-grid';
import { ptBR } from '@mui/x-data-grid/locales'
import { useEffect, useState } from 'react';
import { singleEmpresaType } from './DashboardComponent';
import { Button } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import BorderColorIcon from '@mui/icons-material/BorderColor';

export type userBackObj = {
  email: string,
  id: string,
  matricula: string,
  nome: string,
  role: string,
}

export default function UserComponent({
  usersAdded,
  setUsersAdded,
  userData,
  setUserReports,
  selectedReport,
}: {
  usersAdded: userBackObj[],
  setUsersAdded: Function,
  userData: userBackObj[],
  selectedReport: singleEmpresaType | null,
  setUserReports: Function,
}) {

  const [rows, setRows] = useState<userBackObj[] | GridRowsProp | null>(null);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const optionsMap = [
    { value: 'Selecione', label: 'Selecione' },
    { value: 'rls_cliente', label: 'Cliente' },
    { value: 'rls_conjunto', label: 'Conjunto' },
    { value: 'rls_empresa', label: 'Empresa' },
    { value: 'rls_gerente', label: 'Gerente' },
    { value: 'all', label: 'Total' }
  ]

  useEffect(() => {
    setRows(userData.filter((elem) => !usersAdded?.includes(elem))?.map(ele => ({ ...ele, matricula: "Selecione" })))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usersAdded])


  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true }
    });

  };

  const processRowUpdate = (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows?.map((row) => (row.id === newRow.id ? updatedRow : row)) as userBackObj[]);
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handleRowEditStop: GridEventListener<"rowEditStop"> = (
    params,
    event
  ) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const columns: GridColDef[] = [
    { field: 'nome', headerName: 'Nome', width: 250 },
    { field: 'email', headerName: 'E-mail', width: 250 },
    { field: 'id', headerName: 'User Name', width: 150 },
    { field: 'role', headerName: 'Perfil', width: 100 },
    {
      field: 'matricula', headerName: 'Função', width: 100, editable: true,
      type: "singleSelect", valueOptions: optionsMap,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Editar função",
      width: 120,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              color='success'
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              color='error'
              onClick={() => {
                handleCancelClick(id)
              }}
            />
          ];
        }

        return [
          <GridActionsCellItem
            icon={<BorderColorIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
          />,
        ];
      }
    },
    {
      field: 'add', headerName: 'Adicionar', width: 140, renderCell: (params) => {
        const onClick = () => {
          setUsersAdded((prev: any) => (prev ? [...prev, { ...params.row }] : [prev]));
          setUserReports((prev: any) => prev?.map((report: any) => report.id === selectedReport?.id
            ? { ...report, users: { ...report.users, [params.row.id]: [params.row.matricula] } }
            : report));
        }
        return (
          <Button
            sx={{ textTransform: 'none' }}
            endIcon={<PersonAddIcon />}
            variant='outlined'
            disabled={params.row.matricula === 'Selecione'}
            onClick={() => onClick()}
          >
            Adicionar
          </Button>
        );
      }
    },
  ];

  return (
    <>{userData &&
      <DataGrid
        autoHeight
        getRowId={(row: any) => row.id}
        sx={{ '--DataGrid-overlayHeight': 'fit-content', width: '100%' }}
        getRowHeight={() => 'auto'}
        editMode="row"
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        onRowEditStop={handleRowEditStop}
        processRowUpdate={processRowUpdate}
        rows={rows?.filter((e) => !usersAdded?.some((user: any) => user.nome === e.nome))}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        slotProps={{
          // toolbar: { setRows, setRowModesModel }
        }}
        pageSizeOptions={[10, 25]}
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
      />
    }
    </>
  )
}